import { render, staticRenderFns } from "./OrganizationTypeField.vue?vue&type=template&id=365e26d0"
import script from "./OrganizationTypeField.vue?vue&type=script&lang=js"
export * from "./OrganizationTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports